// Shared constants for the Subscriptions tab modules (iter-105 refactor).

export const PROVIDER_LABELS = {
    anthropic: "Anthropic Claude (direct)",
    anthropic_emergent: "Claude via Emergent",
    openai: "OpenAI GPT",
    gemini: "Google Gemini",
    grok: "xAI Grok",
};
